module.exports = __webpack_public_path__ + "static/media/vinbigdata.1220c5bb.svg";